import {
  DEFAULT_EXTERNAL_ANCHOR_REL,
  DEFAULT_EXTERNAL_ANCHOR_TARGET,
} from '../../../constants/constants';

export function withExternalProperties(props = {}) {
  return { ...props, target: DEFAULT_EXTERNAL_ANCHOR_TARGET, rel: DEFAULT_EXTERNAL_ANCHOR_REL };
}
